/* Alarie - carrito emergente.
   Horizon ya trae un cajon lateral (<theme-drawer id="cart-drawer">) con metodo
   open(). Lo que faltaba era usarlo: el icono del carrito navegaba a /cart y el
   formulario recargaba la pagina. Ahora el icono abre el cajon y al anadir se
   manda por /cart/add.js, se refresca el cajon con una copia recien pedida al
   servidor y se abre. Si no hubiera cajon, todo sigue funcionando como antes. */
(function () {
  'use strict';
  if (window.__alarieCart) return;
  window.__alarieCart = true;

  /* Horizon guarda en sessionStorage que el cajon quedo abierto y lo vuelve a
     abrir en cada pagina. No lo queremos: la cesta solo se abre cuando la
     persona la abre o acaba de anadir algo. Borramos la marca cuanto antes. */
  function forgetOpenState() {
    try { sessionStorage.removeItem('theme-drawer-open'); } catch (e) {}
  }
  forgetOpenState();

  function drawer() {
    var d = document.getElementById('cart-drawer');
    return d && typeof d.open === 'function' ? d : null;
  }

  function openDrawer() {
    var d = drawer();
    if (d) { d.open(); return true; }
    return false;
  }

  /* En movil el componente del cajon carga mas tarde: esperamos a que exista
     (maximo 2,5 s) antes de rendirnos e ir a /cart. */
  function whenDrawer(cb) {
    if (drawer()) { cb(drawer()); return; }
    var done = false;
    function finish(d) { if (done) return; done = true; cb(d); }
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('theme-drawer').then(function () { finish(drawer()); });
    }
    setTimeout(function () { finish(drawer()); }, 2500);
  }

  function closeIfAutoOpened() {
    forgetOpenState();
    var d = drawer();
    if (d && d.isOpen && typeof d.close === 'function') d.close();
  }

  /* Pide la pagina otra vez y cambia el cajon entero por el nuevo, para que
     muestre lo que acaba de entrar. Reemplazar el elemento completo hace que el
     componente vuelva a arrancar solo. */
  async function refresh() {
    var old = document.getElementById('cart-drawer');
    if (!old) return null;
    try {
      var html = await fetch(window.location.pathname, { credentials: 'same-origin' }).then(function (r) { return r.text(); });
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.getElementById('cart-drawer');
      if (!fresh) return old;
      old.replaceWith(fresh);
      return document.getElementById('cart-drawer');
    } catch (e) {
      return old;
    }
  }

  /* Un solo escuchador para toda la pagina (fase de captura): vale para el
     icono de la cabecera, el de la barra flotante y cualquier enlace a /cart,
     aunque se creen o se muevan despues. Asi en movil tambien abre el cajon. */
  function bindIcons() {
    if (window.__alarieCartDeleg) return;
    window.__alarieCartDeleg = true;
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a.al-cart, a[href="/cart"]') : null;
      if (!a || a.closest('#cart-drawer')) return;
      if (!document.getElementById('cart-drawer')) return;
      e.preventDefault();
      e.stopPropagation();
      whenDrawer(function (d) {
        if (d) d.open();
        else window.location.href = a.getAttribute('href') || '/cart';
      });
    }, true);
  }

  /* Color -> id de variante (una variante por color). */
  function vmap() {
    var s = document.querySelector('script[data-al-vmap]');
    if (!s) return null;
    try { return JSON.parse(s.textContent); } catch (e) { return null; }
  }
  /* Lo que va a la cesta: 1 unidad del color elegido, o en el pack una linea
     por color con sus unidades. El 3x2 lo pone el descuento automatico. */
  function items() {
    var map = vmap();
    if (!map) return null;
    var sel = document.querySelector('.al-pdPack--sel');
    var units = sel ? parseInt(sel.getAttribute('data-units') || '1', 10) : 1;
    var cols = [];
    if (sel && units > 1) {
      Array.prototype.forEach.call(sel.querySelectorAll('[data-pk3] select'), function (s) { cols.push(s.value); });
    }
    if (!cols.length) {
      var main = document.querySelector('[data-sw-input]');
      var c = main ? main.value : '';
      for (var i = 0; i < units; i++) cols.push(c);
    }
    /* Variante segun el caso: pack -> "de regalo" (r); 1 unidad con la casilla
       del mosquetón marcada -> "con" (c); 1 unidad sin marcar -> "sin" (s). */
    var addon = sel ? sel.querySelector('[data-addon][aria-checked="true"]') : null;
    /* 2 unidades (oferta señuelo): sueltas, sin regalo; el regalo y el pack solo con 3 */
    var kind = units >= 3 ? 'r' : (addon ? 'c' : 's');
    function vid(color) {
      var m = map[color];
      if (!m) { var keys = Object.keys(map); m = map[keys[0]]; }
      if (typeof m === 'number') return m;
      return m[kind] || m.r || m.s || m.c;
    }
    var count = {}, order = [];
    for (var k = 0; k < cols.length; k++) {
      var id = vid(cols[k]);
      if (!count[id]) { count[id] = 0; order.push(id); }
      count[id]++;
    }
    var pack = units >= 3 ? String(Date.now()) : '';
    return order.map(function (id) {
      var it = { id: id, quantity: count[id] };
      /* el pack viaja marcado (propiedad oculta) para ensenarlo junto en la cesta */
      if (pack) it.properties = { _packid: pack, _pack: 'Llevate 3, paga 2', 'Regalo': 'Mosquetón dorado (uno por alarma)' };
      return it;
    });
  }

  /* "✓ Añadido" encima del texto del boton (el texto y el precio no se tocan, solo se ocultan) */
  function added(btn) {
    if (!btn) return;
    if (!document.getElementById('al-added-css')) {
      var c = document.createElement('style');
      c.id = 'al-added-css';
      c.textContent = '.al .al-pdAdd.is-added{position:relative;color:transparent !important}' +
        '.al .al-pdAdd.is-added *{visibility:hidden}' +
        '.al .al-pdAdd.is-added::after{content:"\\2713\\00a0 A\\00f1 adido";position:absolute;inset:0;display:flex;align-items:center;justify-content:center;color:#fff;animation:alAddedIn .25s cubic-bezier(.34,1.6,.5,1)}' +
        '@keyframes alAddedIn{from{opacity:0;transform:scale(.85)}to{opacity:1;transform:none}}' +
        '@media(prefers-reduced-motion:reduce){.al .al-pdAdd.is-added::after{animation:none}}';
      document.head.appendChild(c);
    }
    btn.classList.add('is-added');
    setTimeout(function () { btn.classList.remove('is-added'); }, 1800);
  }

  function bindForm() {
    var form = document.getElementById('alForm');
    if (!form || form.dataset.cartBound) return;
    form.dataset.cartBound = '1';
    form.addEventListener('submit', function (e) {
      var list = items();
      /* por si hubiera que mandar el formulario normal: el color de arriba */
      var idField = document.getElementById('alVariantId');
      if (list && list.length && idField) idField.value = list[0].id;
      var qty = document.getElementById('alQty');
      if (list && list.length === 1 && qty) qty.value = list[0].quantity;
      if (!list || !document.getElementById('cart-drawer')) return;
      e.preventDefault();
      var btn = form.querySelector('.al-pdAdd');
      if (btn) btn.setAttribute('aria-busy', 'true');
      fetch('/cart/add.js', {
        method: 'POST',
        body: JSON.stringify({ items: list }),
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
      }).then(function (r) {
        if (!r.ok) throw new Error('add');
        return refresh();
      }).then(function (d) {
        if (btn) btn.removeAttribute('aria-busy');
        bindIcons();
        /* El boton confirma "Anadido" un momento y despues se abre la cesta */
        added(btn);
        setTimeout(function () {
          whenDrawer(function (dd) {
            if (dd) dd.open();
            else window.location.href = '/cart';
          });
        }, btn ? 650 : 0);
      }).catch(function () {
        if (btn) btn.removeAttribute('aria-busy');
        form.submit();
      });
    });
  }

  /* Para que la caja del pack pueda refrescar el cajon al quitarlo */
  window.alCartReload = function () {
    return refresh().then(function () { bindIcons(); whenDrawer(function (d) { if (d) d.open(); }); });
  };

  /* Cambia la cesta SIN salir de ella: manda el cambio, pide la pagina otra
     vez y solo cambia el contenido de dentro del cajon (el cajon sigue
     abierto). Tambien actualiza el numerito del icono de la cesta. */
  function updateInPlace(up, b) {
    var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
    var box = b.closest('.cart-drawer__inner, cart-drawer-component, main') || document.body;
    box.style.transition = 'opacity .15s'; box.style.opacity = '.55'; box.style.pointerEvents = 'none';
    function done() { box.style.opacity = ''; box.style.pointerEvents = ''; }
    fetch(root + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: up })
    }).then(function () {
      return fetch(window.location.pathname + window.location.search, { credentials: 'same-origin' }).then(function (r) { return r.text(); });
    }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      /* dentro del cajon: cambiamos el componente de dentro, no el cajon */
      var oldC = document.querySelector('#cart-drawer cart-drawer-component');
      var newC = doc.querySelector('#cart-drawer cart-drawer-component');
      if (oldC && newC && b.closest('#cart-drawer')) oldC.replaceWith(document.importNode(newC, true));
      else {
        /* pagina /cart: cambiamos el contenido principal */
        var oldM = document.querySelector('main'), newM = doc.querySelector('main');
        if (oldM && newM) oldM.innerHTML = newM.innerHTML; else { window.location.reload(); return; }
        var oc = document.querySelector('#cart-drawer cart-drawer-component');
        var nc = doc.querySelector('#cart-drawer cart-drawer-component');
        if (oc && nc) oc.replaceWith(document.importNode(nc, true));
      }
      /* numerito del icono */
      var fresh = doc.querySelector('.al-cart__n');
      Array.prototype.forEach.call(document.querySelectorAll('a.al-cart'), function (a) {
        var n = a.querySelector('.al-cart__n');
        if (fresh) { if (!n) { n = document.createElement('span'); n.className = 'al-cart__n'; a.appendChild(n); } n.textContent = fresh.textContent; }
        else if (n) n.remove();
      });
      done();
    }).catch(function () { window.location.reload(); });
  }

  /* Boton "Quitar" de la caja del pack: pone a 0 todas sus lineas.
     Va en fase de captura para que ningun otro script del tema se lo coma. */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-al-pack-rm]') : null;
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    if (b.dataset.busy) return;
    b.dataset.busy = '1';
    b.textContent = 'Quitando...';
    var up = {};
    (b.getAttribute('data-al-pack-rm') || '').split(',').forEach(function (k) { if (k) up[k] = 0; });
    updateInPlace(up, b);
  }, true);

  /* Botones - / + de las alarmas sueltas en la cesta */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-al-qty]') : null;
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    if (b.dataset.busy) return;
    b.dataset.busy = '1';
    var up = {};
    up[b.getAttribute('data-al-qty')] = Math.max(0, parseInt(b.getAttribute('data-q'), 10) || 0);
    updateInPlace(up, b);
  }, true);

  /* Aviso 3x2 de la cesta ("+ Anadir" y "Crear pack 3x2"). Antes iba dentro del
     snippet de la cesta y no se cargaba si la cesta se abria despues de anadir
     desde la ficha; aqui se carga siempre. */
  /* Cuadradito con la foto del color elegido en el selector del pack */
  function alTh(s) {
    var o = s.options[s.selectedIndex], th = s.parentNode.querySelector('.al-up__th');
    if (!o || !th) return;
    var src = o.getAttribute('data-img'), img = th.querySelector('img');
    if (src) { if (!img) { img = document.createElement('img'); img.alt = ''; th.appendChild(img); } img.src = src; }
    else if (img) img.remove();
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-al-col]')) alTh(e.target);
  });
  function openPick(btn, color) {
    var scope = btn.closest('cart-drawer-component, main') || document;
    var pk = scope.querySelector('.al-up__pick');
    if (!pk) return false;
    pk.removeAttribute('hidden');
    var o = scope.querySelector('[data-al-open]'); if (o) o.setAttribute('aria-expanded', 'true');
    if (color) {
      var sels = pk.querySelectorAll('[data-al-col]'), last = sels[sels.length - 1];
      if (last) Array.prototype.forEach.call(last.options, function (op) { if (op.text.trim() === color) last.value = op.value; });
      if (last) alTh(last);
    }
    var up = pk.closest('.al-up') || pk;
    if (up.scrollIntoView) up.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    return true;
  }
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var o = e.target.closest('[data-al-open]');
    if (o) {
      e.preventDefault(); e.stopPropagation();
      var pk = o.parentNode.querySelector('.al-up__pick'); if (!pk) return;
      var open = pk.hasAttribute('hidden'); if (open) pk.removeAttribute('hidden'); else pk.setAttribute('hidden', '');
      o.setAttribute('aria-expanded', open ? 'true' : 'false'); return;
    }
    /* "+" en una suelta cuando ya hay 2: en vez de una tercera suelta, abre el pack */
    var t = e.target.closest('[data-al-topack]');
    if (t) { e.preventDefault(); e.stopPropagation(); openPick(t, t.getAttribute('data-al-topack')); return; }
    var b = e.target.closest('[data-al-up]'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    if (b.disabled) return; b.disabled = true; b.textContent = 'Creando el pack...';
    var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
    var box = b.closest('.al-up__pick');
    /* Las sueltas se quitan y se crea un pack 3x2 con el color elegido para cada una */
    var zero = {}, count = {}, add = [], pack = String(Date.now());
    var props = { _packid: pack, _pack: 'Llevate 3, paga 2', 'Regalo': 'Mosquetón dorado (uno por alarma)' };
    /* se quitan de las sueltas tantas unidades como entran en el pack (3 como mucho) */
    var take = 3;
    (box.getAttribute('data-lines') || '').split(';').forEach(function (l) {
      var p = l.split('|'); if (p.length < 3 || take <= 0) return;
      var q = parseInt(p[2], 10) || 0, quita = Math.min(q, take);
      zero[p[0]] = q - quita; take -= quita;
    });
    Array.prototype.forEach.call(box.querySelectorAll('[data-al-col]'), function (s) { var v = s.value; count[v] = (count[v] || 0) + 1; });
    Object.keys(count).forEach(function (v) { add.push({ id: parseInt(v, 10), quantity: count[v], properties: props }); });
    var H = { 'Content-Type': 'application/json', Accept: 'application/json' };
    fetch(root + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: H, body: JSON.stringify({ updates: zero }) })
    .then(function () {
      return fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: H, body: JSON.stringify({ items: add }) });
    }).then(function () {
      updateInPlace({}, b);
    }).catch(function () { window.location.reload(); });
  }, true);

  /* La X de la cesta: en la ficha cierra y sube arriba del todo (producto y
     ofertas a la vista). En cualquier otra pagina lleva a la ficha. */
  var FICHA = '/products/alarma-personal-135-db-con-linterna-led';
  function toTop() {
    var pw = document.querySelector('.page-wrapper');
    window.scrollTo({ top: 0, behavior: 'smooth' });
    if (pw) pw.scrollTo({ top: 0, behavior: 'smooth' });
  }
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var x = e.target.closest('#cart-drawer .theme-drawer__close-button, #cart-drawer .cart-drawer__close-button--empty');
    if (!x) return;
    if (document.getElementById('alForm')) { setTimeout(toTop, 80); return; }
    e.preventDefault();
    e.stopPropagation();
    forgetOpenState();
    window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root.replace(/\/$/, '') : '') + FICHA;
  }, true);

  function init() { closeIfAutoOpened(); bindIcons(); bindForm(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('load', closeIfAutoOpened);
  /* Al volver atras (desde la cesta, el pago, etc.) el navegador ensena la
     pagina congelada tal cual se dejo, con la cesta a medio abrir y la pagina
     bloqueada. Si la pagina viene de esa copia congelada, se recarga limpia. */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) { forgetOpenState(); window.location.reload(); }
  });
  document.addEventListener('shopify:section:load', function () { bindIcons(); bindForm(); });
})();
